import { Box, styled } from '@mui/material';

export const RootBox = styled(Box)`
    padding: 48px 48px;
`;
